import type { ReactNode } from 'react';
import { runnerTheme } from '../styles/runnerTheme';
import { Box, Typography } from '@glplus/glpweb-dsl';

/** Deck panel card: white, rounded, colored top accent (navy / orange / green / grey). */
/**
 * The title is a real heading so screen readers can move between panels — h2
 * under a page's h1, or h1 when the panel IS the page (headingLevel="h1").
 */
export function Panel({ title, accent = '#343F5B', children, sx, headingLevel = 'h2', dataTestId }: { title?: ReactNode; accent?: string; children: ReactNode; sx?: Record<string, unknown>; headingLevel?: 'h1' | 'h2' | 'h3'; dataTestId?: string }) {
  return (
    <Box data-testid={dataTestId} sx={{ backgroundColor: '#fff', border: '1px solid #E2E6EE', borderRadius: '10px', borderTop: `4px solid ${accent}`, overflow: 'hidden', p: 2, ...(sx ?? {}) }}>
      {title && <Typography component={headingLevel} sx={{ m: 0, fontWeight: 800, fontSize: '17px', color: runnerTheme.navy, mb: 1.5 }}>{title}</Typography>}
      {children}
    </Box>
  );
}
